import { partner } from '@/sidebar/infrastructure/clients/partner';
import { ProfileRole } from '@/sidebar/domain/enums/ProfileRole';

export type Responsible = {
  name: string;
  email: string;
  cellphone: string;
  cellphoneCode: string;
};

export type ProfileBranchResponse = {
  source: string;
  responsible: Responsible;
};

export type ProfileResponse = {
  name: string;
  branch: ProfileBranchResponse;
  type: keyof typeof ProfileRole;
};

export const getProfileApi = async () => {
  try {
    const response: ProfileResponse = await partner().get('/accesses/current');

    return {
      name: response?.name,
      source: response?.branch?.source?.toUpperCase(),
      responsible: {
        name: response?.branch?.responsible?.name,
        email: response?.branch?.responsible?.email,
        cellphone: response?.branch?.responsible?.cellphone,
        cellphone_code: response?.branch?.responsible?.cellphoneCode,
      },
      role: ProfileRole[response?.type],
    };
  } catch (error) {
    return error;
  }
};
